export const versionCounter = {
  version: 0,
};
